export type CountryCode = 'gb' | 'ie' | 'fr';
export type CurrencyUnit = 'pence' | 'cents';
export type CurrencyBase = 'pound' | 'euro';

export const COUNTRY_DEFINITIONS: Array<{
  code: CountryCode;
  label: string;
  currencyUnit: CurrencyUnit;
  currencyBase: CurrencyBase;
}> = [
  { code: 'gb', label: 'United Kingdom', currencyUnit: 'pence', currencyBase: 'pound' },
  { code: 'fr', label: 'France', currencyUnit: 'cents', currencyBase: 'euro' },
  { code: 'ie', label: 'Ireland', currencyUnit: 'cents', currencyBase: 'euro' },
];

export const COUNTRY_OPTIONS = COUNTRY_DEFINITIONS.map(({ code, label }) => ({ code, label }));

export const COUNTRY_META = COUNTRY_DEFINITIONS.reduce(
  (acc, country) => {
    acc[country.code] = {
      label: country.label,
      currencyUnit: country.currencyUnit,
      currencyBase: country.currencyBase,
    };
    return acc;
  },
  {} as Record<CountryCode, { label: string; currencyUnit: CurrencyUnit; currencyBase: CurrencyBase }>
);

export const DEFAULT_COUNTRY_CODE: CountryCode = 'gb';
